import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { Subject, takeUntil } from 'rxjs';
import { RecentlyAddedAssetItem, RecentlyAddedAssetsDataService } from '../../data-access/widgets/recently-added-assets-data.service';

@Component({
  selector: 'app-recently-added-assets-widget',
  template: `
    <app-dashboard-card title="Recently Added Assets">
      <div *ngIf="loading">Loading assets...</div>
      <div *ngIf="!loading && error" class="error">{{ error }}</div>
      <div *ngIf="!loading && !error && items.length === 0">No assets</div>
      <mat-list *ngIf="!loading && !error && items.length > 0" class="assets-list dashboard-scroll-list">
        <mat-list-item *ngFor="let item of items; trackBy: trackByAsset" (click)="selectAsset(item)" class="assets-list-item dashboard-scroll-list-item" [attr.aria-label]="'Open asset ' + item.assetName">
          {{ item.assetName }}
        </mat-list-item>
      </mat-list>
    </app-dashboard-card>
  `,
  styles: [
    `.dashboard-scroll-list { display: block; max-height: 280px; overflow-y: auto; background: var(--table-row-bg); border-radius: 6px; }`,
    `.dashboard-scroll-list-item { min-height: 36px; color: var(--table-heading); }`,
    `.assets-list-item { cursor: pointer; }`,
    `.assets-list-item:nth-child(odd) { background: var(--table-row-bg); }`,
    `.assets-list-item:nth-child(even) { background: var(--table-row-alternate-bg); }`,
    `.assets-list-item:hover { background: var(--table-row-hover); border-radius: 6px; }`,
    `@media (max-width: 768px) { .dashboard-scroll-list { max-height: 220px; } }`
  ]
})
export class RecentlyAddedAssetsWidgetComponent implements OnInit, OnDestroy {
  items: RecentlyAddedAssetItem[] = [];
  loading = false;
  error = '';
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly dataService: RecentlyAddedAssetsDataService,
    private readonly stateService: StateService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.error = '';
    this.dataService.getAssets()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: items => this.items = items,
        error: () => {
          this.error = 'Unable to load assets';
          this.items = [];
        },
        complete: () => this.loading = false
      });
  }

  selectAsset(item: RecentlyAddedAssetItem): void {
    const assetId = item.assetId;
    if (!assetId) {
      return;
    }

    this.stateService.go('assets.search.asset', {
      projectID: assetId,
      projectName: encodeURIComponent(item.assetName),
      caption: 'Asset Details'
    });
  }

  trackByAsset(_: number, item: RecentlyAddedAssetItem): string {
    return item.assetId;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
